type AssetValuationConfig = {
  /** 币币现货 */
  showCoinsBalance?: boolean
  /** 合约 */
  showContractBalance?: boolean
  /** 股票 */
  showStockBalance?: boolean
  /** 理财 */
  showFinanceBalance?: boolean
  /** 超级杠杆 */
  showSuperLeverageBalance?: boolean
  /** 金融卡 */
  showDebitCardBalance?: boolean
  /** 跟单 */
  showCopyTradeBalance?: boolean
}

const platform = import.meta.env.VITE_PLATFORM

/** 交易所 */
const CRYPTO_CONFIG: AssetValuationConfig = {
  showCoinsBalance: true,
  showContractBalance: true,
  showStockBalance: true,
  showFinanceBalance: true,
  showSuperLeverageBalance: true,
  showDebitCardBalance: true,
  showCopyTradeBalance: true,
}

const NOT_CRYPTO_CONFIG: AssetValuationConfig = {
  showCoinsBalance: false,
  showContractBalance: false,
  showStockBalance: false,
  showFinanceBalance: false,
}

const HASH_SPACE_CONFIG: AssetValuationConfig = NOT_CRYPTO_CONFIG

const BGE_CONFIG: AssetValuationConfig = NOT_CRYPTO_CONFIG

type PlatformName = ImportMetaEnv['VITE_PLATFORM']

type ConfigMap = Partial<Record<PlatformName, Partial<AssetValuationConfig>>>

const CONFIG_MAP: ConfigMap = {
  topcredit: CRYPTO_CONFIG,
  '8v': CRYPTO_CONFIG,
  e97: CRYPTO_CONFIG,
  hashspace: HASH_SPACE_CONFIG,
  bge: BGE_CONFIG,
  b9: CRYPTO_CONFIG,
}

export enum AssetType {
  Digital = 1,
  Fiat = 2,
}

export type AssetTab = {
  type: AssetType
  title: string
}

const CRYPTO_ASSET_TABS: AssetTab[] = [
  {
    type: AssetType.Digital,
    title: '数字货币',
  },
  {
    type: AssetType.Fiat,
    title: '法币',
  },
]

const NOT_CRYPTO_ASSET_TABS: AssetTab[] = [
  {
    type: AssetType.Digital,
    title: '数字货币',
  },
]

const HASH_SPACE_ASSET_TABS: AssetTab[] = NOT_CRYPTO_ASSET_TABS

const BGE_ASSET_TABS: AssetTab[] = NOT_CRYPTO_ASSET_TABS

type AssetTabsMap = Partial<Record<PlatformName, AssetTab[]>>

const ASSET_TABS_MAP: AssetTabsMap = {
  topcredit: CRYPTO_ASSET_TABS,
  '8v': CRYPTO_ASSET_TABS,
  e97: CRYPTO_ASSET_TABS,
  hashspace: HASH_SPACE_ASSET_TABS,
  bge: BGE_ASSET_TABS,
  b9: CRYPTO_ASSET_TABS,
}

export const ASSET_TABS = ASSET_TABS_MAP[platform] || CRYPTO_ASSET_TABS

export const ASSET_VALUATION_CONFIG: Partial<AssetValuationConfig> = CONFIG_MAP[platform] || CRYPTO_CONFIG
